import {
  TempAmountSceneEnum, TempAmountStatus, EventLoopNotifySceneEnum, ApplyTempAmountResult,
} from '@/api/tempAmount/types';

// 临额状态数据
export interface StateType {
  /** 临时额度-下发状态(下发状态、下发金额) */
  tempAmountStatus: TempAmountStatus | null;
  /** 倒计时时间：申请下发临时额度后端返回的时间 */
  tempTimeout: number;
  /** 当用户已进入提现流程了，则不打扰用户，提现页停止更新 的临额额度下发 */
  applyProductSuspendFeelTempAmount: boolean,
}

export interface GettersType {
  isHasIssuedTempAmount: boolean,
  isHasApplyingTempAmount: boolean
}

export interface RequestApplyParams {
  scene: TempAmountSceneEnum;
}

export interface CheckTempStatusParams {
  /** 检测当前临额下发状态-限定页面hash，不设置则直接取location.hash */
  targetHash?: string;
}

// Action 类型定义
export interface StoreActionType {
  /** 检测用户当前状态-是否不存在临时额度 */
  checkNotExistTempAmount: (params?: CheckTempStatusParams) => Promise<boolean>;

  /** 轮询查询临时额度是否下发成功 */
  pollingTempAmountIssued?: (payload: {
    pollingCount?: number;
    targetHash?: string;
  }) => Promise<boolean>;

  /** 请求申请临额额度 */
  requestApplyTempAmount: (params: RequestApplyParams) => Promise<ApplyTempAmountResult>;

  /** 申请提额下发临额 */
  creditApplyTempAmount: () => Promise<boolean>;

  /** 更新临时额度下发状态的感知 */
  updateSuspendFeelTempAmount?: (payload: {
    isApplyProductSuspendFeel?: boolean;
  }) => Promise<void>;

  /** 通用轮询消息，检查服务端是否有变更下发 */
  commonPollingNotifyIssued: (payload: {
    loopSceneList: EventLoopNotifySceneEnum[];
  }) => Promise<void>;
}

export { TempAmountSceneEnum };
